import { Section, SubSection } from 'shared/location-enums';
import { Article, Image } from 'shared/types';

export interface ButtonDetailListLink {
    title: string;
    onClick: () => void;
}

export interface ButtonDetailListItem extends Article {
    panelTitle?: string;
    items?: ButtonDetailListItem[];
    link?: ButtonDetailListLink;
    bullets?: string[];
    additionalArticles?: ButtonDetailListItem[];
}

export interface TopTab {
    title: string;
    sectionHeader?: string;
    section: Section;
    subSection: SubSection;
    items?: ButtonDetailListItem[];
    type: PanelType;
    img?: Image;
    order?: number;
}

export const PanelType = {
    normal: 'normal',
    info: 'info',
    accounts: 'accounts',
} as const;

export type PanelType = (typeof PanelType)[keyof typeof PanelType];
